import axxessMessagingLandingPage from "../MessageCenter/axxess-messaging-landing-page-routes";

import CentralMessaging from "../MessageCenter/CentralMessaging/CentralMessaging.vue";
import CentralClinician from "../Clinician/CentralClinician.vue";

const routes: any = [
    {
        name: "Axxess Connect",
        path: "/central-messaging/clinicians/conversation",
        component: CentralMessaging,
        meta: {
            menuName: "Axxess Connect",
            navItem: "tabMessaging",
            showAxxessConnect: true
        },
        children: axxessMessagingLandingPage
    },
    {
        name: "Axxess Planner",
        path: "/clinician",
        component: CentralClinician,
        meta: {
            menuName: "Axxess Planner",
            navItem: "tabClinician"
        }
    }
];

export default routes;
